import { render, staticRenderFns } from "./edit.notifications.page.vue?vue&type=template&id=64e9c418&"
import script from "./edit.notifications.page.vue?vue&type=script&lang=js&"
export * from "./edit.notifications.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports